import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MS - Orthopedics, Fellowship in Hand Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Carpal Tunnel Syndrome Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, MD - Physical Medicine & Rehabilitation",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Non-Surgical CTS Treatment Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MS - Orthopedics, MCh - Hand & Microsurgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced CTS Surgery Expert"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MD - Physical Medicine, Fellowship in Pain Management",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "CTS Rehabilitation Specialist"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MS - Orthopedics, Fellowship in Hand Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Minimally Invasive CTS Surgery Expert"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, DNB - Orthopedics",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Carpal Tunnel Release Specialist"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Carpal Tunnel Syndrome Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert care for carpal tunnel relief with 95% success rate. Comprehensive non-surgical and surgical solutions for wrist pain and numbness.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const CarpalTunnelSyndrome = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Carpal Tunnel Syndrome Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Complete Carpal Tunnel Relief with 95% Success Rate. Non-Surgical & Surgical Solutions for Hand Numbness and Pain.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Emergency CTS Care
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>95%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Treatment Success Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>15-30</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Minutes Procedure Time</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>2-6</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Weeks Full Recovery</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>{`<2%`}</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Complication Rate</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "symptoms", label: "Symptoms", icon: "🔍" },
              { id: "treatments", label: "Treatments", icon: "🎯" },
              { id: "procedure", label: "Procedure", icon: "🔬" },
              { id: "recovery", label: "Recovery", icon: "⚕️" },
              { id: "prevention", label: "Prevention", icon: "🔄" },
              { id: "faq", label: "FAQ", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Carpal Tunnel Syndrome Treatment</span>
            </h2>
          </div>

          {/* What is Carpal Tunnel Syndrome */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Carpal Tunnel Syndrome
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                Carpal Tunnel Syndrome (CTS) is a common condition that occurs when the median nerve, which runs from 
                your forearm into your hand, becomes compressed or squeezed at the wrist. This compression happens within 
                the carpal tunnel - a narrow passageway surrounded by bones and ligaments on the palm side of your hand. 
                When this nerve is compressed, it can cause pain, numbness, tingling, and weakness in the hand and arm.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Common Causes</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Repetitive hand movements, wrist anatomy, health conditions like diabetes and arthritis, 
                      pregnancy, and obesity are common factors that can lead to carpal tunnel compression.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Risk Factors</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Women are three times more likely to develop CTS. Other risk factors include family history, 
                      workplace factors, and certain medical conditions that affect nerves.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Symptoms & Signs */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Symptoms & Clinical Presentation
            </h3>

            <div className="row">
              {[
                {
                  title: "Numbness & Tingling", 
                  description: "Pins and needles sensation in thumb, index, middle, and ring fingers, often worse at night",
                  details: "Classic symptom affecting first three fingers"
                },
                {
                  title: "Hand Pain", 
                  description: "Dull ache or sharp pain in wrist, palm, or radiating up the arm, especially after repetitive use",
                  details: "Often worse at night or upon waking"
                },
                {
                  title: "Weak Grip", 
                  description: "Difficulty holding objects, frequent dropping of items, reduced hand strength",
                  details: "Affects fine motor skills and grip strength"
                },
                {
                  title: "Burning Sensation", 
                  description: "Uncomfortable burning feeling in fingers and palm that may travel up the forearm",
                  details: "Indicates nerve irritation"
                },
                {
                  title: "Swollen Feeling", 
                  description: "Sensation of swelling in fingers without actual visible swelling present",
                  details: "Common complaint despite no physical swelling"
                },
                {
                  title: "Temperature Sensitivity", 
                  description: "Fingers feel excessively cold or warm, or differences in temperature perception",
                  details: "Nerve compression affects temperature sensation"
                }
              ].map((symptom, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {symptom.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {symptom.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {symptom.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Treatment Types & Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Carpal Tunnel Treatment Options
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Non-Surgical Treatments",
                    description: "Conservative approaches including splinting, activity modification, and medications",
                    treatment: "First-line treatment for mild to moderate CTS"
                  },
                  {
                    type: "Corticosteroid Injections",
                    description: "Anti-inflammatory injections to reduce swelling and relieve nerve pressure",
                    treatment: "Effective for temporary to long-term relief"
                  },
                  {
                    type: "Physical Therapy",
                    description: "Specialized exercises and techniques to improve nerve gliding and reduce compression",
                    treatment: "Improves strength and flexibility"
                  },
                  {
                    type: "Open Carpal Tunnel Release",
                    description: "Traditional surgical approach with single incision to cut transverse carpal ligament",
                    treatment: "Gold standard for severe cases"
                  },
                  {
                    type: "Endoscopic Surgery",
                    description: "Minimally invasive technique using small incisions and camera guidance",
                    treatment: "Faster recovery, smaller scars"
                  },
                  {
                    type: "Ultrasound-Guided Procedures",
                    description: "Precise injections and procedures using real-time ultrasound imaging",
                    treatment: "Enhanced accuracy and effectiveness"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Causes & Risk Factors */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Causes & Risk Factors
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Primary Causes</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Repetitive hand and wrist movements</li>
                      <li style={{ marginBottom: "10px" }}>Awkward hand positions during work</li>
                      <li style={{ marginBottom: "10px" }}>Prolonged use of vibrating hand tools</li>
                      <li style={{ marginBottom: "10px" }}>Direct trauma or injury to the wrist</li>
                      <li>Anatomical factors and genetic predisposition</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Risk Factors</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Female gender (3 times more common)</li>
                      <li style={{ marginBottom: "10px" }}>Diabetes and other metabolic disorders</li>
                      <li style={{ marginBottom: "10px" }}>Rheumatoid arthritis and inflammatory conditions</li>
                      <li style={{ marginBottom: "10px" }}>Obesity and fluid retention</li>
                      <li>Workplace factors and repetitive strain</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Treatment Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Non-Surgical Management
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Conservative treatments are often effective for mild to moderate carpal tunnel syndrome 
                    and should be tried before considering surgical options. These approaches focus on 
                    reducing pressure on the median nerve and managing symptoms.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Conservative Treatments:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Wrist splinting</li>
                          <li style={{ marginBottom: "8px" }}>Activity modification</li>
                          <li style={{ marginBottom: "8px" }}>NSAID medications</li>
                          <li style={{ marginBottom: "8px" }}>Nerve gliding exercises</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Corticosteroid injections</li>
                          <li style={{ marginBottom: "8px" }}>Physical therapy</li>
                          <li style={{ marginBottom: "8px" }}>Yoga and stretching</li>
                          <li style={{ marginBottom: "8px" }}>Workplace ergonomics</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Effectiveness:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}>60-70% success rate for mild cases</li>
                      <li style={{ marginBottom: "8px" }}>Symptom relief within 2-4 weeks</li>
                      <li style={{ marginBottom: "8px" }}>Long-term management possible</li>
                      <li>Prevents progression to severe stages</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Surgical Treatment Options
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Surgical Procedures:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}><strong>Open Carpal Tunnel Release:</strong> Traditional approach with direct visualization</li>
                      <li style={{ marginBottom: "10px" }}><strong>Endoscopic Release:</strong> Minimally invasive with camera guidance</li>
                      <li style={{ marginBottom: "10px" }}><strong>Mini-Open Technique:</strong> Smaller incision with direct access</li>
                      <li style={{ marginBottom: "10px" }}><strong>Ultrasound-Guided Release:</strong> Real-time imaging for precision</li>
                      <li><strong>Revision Surgery:</strong> For failed previous procedures</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Surgical Benefits:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>95% success rate for symptom relief</li>
                      <li style={{ marginBottom: "10px" }}>Permanent solution for nerve compression</li>
                      <li style={{ marginBottom: "10px" }}>Quick procedure (15-30 minutes)</li>
                      <li style={{ marginBottom: "10px" }}>Local anesthesia options available</li>
                      <li>Rapid return to normal activities</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Advanced Techniques:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Nerve conduction studies for precise diagnosis</li>
                      <li style={{ marginBottom: "10px" }}>Customized surgical approach based on anatomy</li>
                      <li>Comprehensive post-operative rehabilitation</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Recovery Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Treatment & Recovery Timeline
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Week 1-2",
                    title: "Initial Recovery",
                    activities: ["Pain management", "Wound care", "Limited hand use", "Symptom improvement begins"]
                  },
                  {
                    period: "Week 3-4",
                    title: "Early Healing",
                    activities: ["Suture removal", "Increased activity", "Physical therapy", "Strength exercises"]
                  },
                  {
                    period: "Month 2-3",
                    title: "Functional Recovery",
                    activities: ["Normal daily activities", "Work return", "Full range of motion", "Continued improvement"]
                  },
                  {
                    period: "Month 4-6",
                    title: "Full Recovery",
                    activities: ["Maximum strength return", "All activities resumed", "Scar maturation", "Optimal function"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Prevention & Aftercare */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Prevention & Post-treatment Care
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Prevention Strategies</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Maintain proper wrist position during work</li>
                      <li style={{ marginBottom: "10px" }}>Take frequent breaks during repetitive tasks</li>
                      <li style={{ marginBottom: "10px" }}>Use ergonomic tools and equipment</li>
                      <li>Perform regular wrist stretches and exercises</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Post-treatment Care</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Follow prescribed physical therapy program</li>
                      <li style={{ marginBottom: "10px" }}>Gradually increase hand activities as tolerated</li>
                      <li style={{ marginBottom: "10px" }}>Attend all follow-up appointments</li>
                      <li>Report any new or worsening symptoms immediately</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "How painful is carpal tunnel surgery?",
                  answer: "Carpal tunnel surgery is typically well-tolerated with minimal pain. The procedure is performed under local anesthesia with sedation, so you won't feel pain during the surgery. After the procedure, most patients experience mild to moderate discomfort that is easily managed with over-the-counter pain medication. The pain is usually described as soreness rather than sharp pain, and it significantly improves within the first 48-72 hours. Many patients report that the relief from their carpal tunnel symptoms begins almost immediately after surgery, making the temporary surgical discomfort well worth it. Your surgeon will provide detailed pain management instructions and medications to ensure your comfort throughout the recovery process. Most patients are pleasantly surprised by how manageable the post-operative pain is compared to their pre-surgery symptoms."
                },
                {
                  question: "How long does it take to recover from carpal tunnel surgery?",
                  answer: "Recovery from carpal tunnel surgery follows a predictable timeline: First 1-2 weeks: Initial healing with wound care and limited hand use; Weeks 2-4: Gradual return to light activities and beginning of physical therapy; Weeks 4-6: Increased activity level and strength training; Months 2-3: Near-normal function with continued improvement; Months 4-6: Full recovery with maximum strength and function. Most patients can return to desk work within 1-2 weeks and more physically demanding jobs within 4-6 weeks. The speed of recovery depends on the surgical technique used (endoscopic typically has faster recovery), your overall health, and how well you follow post-operative instructions. Complete relief from numbness and tingling may take several weeks to months as the nerve recovers from long-term compression."
                },
                {
                  question: "What is the success rate of carpal tunnel surgery?",
                  answer: "Carpal tunnel surgery has an excellent success rate of 90-95% for properly selected patients. Success is measured by: Complete or significant relief of numbness and tingling; Resolution of night-time symptoms; Improved hand strength and function; Ability to return to normal activities; Patient satisfaction with outcomes. Factors that contribute to this high success rate include: Accurate diagnosis through nerve conduction studies; Proper patient selection and timing of surgery; Skilled surgical technique; Appropriate post-operative rehabilitation; Addressing underlying contributing factors. While most patients experience dramatic improvement, some may have residual symptoms if nerve damage was severe or long-standing. However, even in these cases, surgery typically prevents further progression and provides significant symptom relief. The success rate is one of the highest among all surgical procedures for nerve compression."
                },
                {
                  question: "Can carpal tunnel syndrome come back after surgery?",
                  answer: "Recurrence of carpal tunnel syndrome after surgery is uncommon but possible in about 2-5% of cases. Factors that may contribute to recurrence include: Incomplete release of the transverse carpal ligament; Scar tissue formation around the nerve; Development of new medical conditions like arthritis or diabetes; Return to repetitive activities without proper ergonomics; Anatomical variations or persistent inflammation. When recurrence does happen, it's usually milder than the original condition and can often be managed with conservative treatments. Revision surgery may be considered if symptoms are severe and conservative measures fail. To minimize recurrence risk, it's important to: Follow post-operative rehabilitation guidelines; Maintain good wrist ergonomics; Manage underlying health conditions; Perform regular stretching exercises. Most patients enjoy permanent relief after successful carpal tunnel release surgery."
                },
                {
                  question: "What's the difference between open and endoscopic carpal tunnel surgery?",
                  answer: "Both open and endoscopic carpal tunnel release achieve the same goal - cutting the transverse carpal ligament to relieve pressure on the median nerve. The main differences are: Open surgery involves a 2-3 inch incision in the palm, allowing direct visualization of the structures. It has a longer track record and may be preferred for complex cases. Endoscopic surgery uses one or two smaller incisions (about 1/2 inch) and a tiny camera to guide the procedure. It typically offers: Faster initial recovery with less early post-operative pain; Smaller scars and better cosmetic appearance; Quicker return to work and activities; Potentially less scar tenderness. However, endoscopic surgery requires specialized training and equipment, and may have a slightly higher risk of nerve injury in inexperienced hands. Both techniques have excellent success rates when performed by skilled surgeons. Your doctor will recommend the best approach based on your specific anatomy, symptoms, and lifestyle needs."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Need Carpal Tunnel Relief?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert team provides comprehensive carpal tunnel treatment with 95% success rate and rapid recovery.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Orthopedics: <strong>080-6541-7705</strong> | Hand Surgery: <strong>080-6541-7715</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default CarpalTunnelSyndrome;